module.exports = __webpack_public_path__ + "img/Kdiamante.6b5b30c0.png";